<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oqEWyv/tc-custom/9781497672529.jpg?1705492240047" alt="This image is the cover for the book Four Corners of the World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Four Corners of the World
      </h1>
      <p class="bookDescription body article font2">
        <b>A scintillating collection of mysteries and adventures from the brilliant mind of A. E. W. Mason</b><br/><br/> When Archie Cranfield’s father asked Mr. Twiss to look after his son as well as advise him financially, the solicitor had no idea what he was agreeing to. A furtive smile permanently etched on his face, Archie lives alone in the countryside. His neighbors do not like him, and Captain Brayton, a former schoolmate, had a falling-out with him years ago and has not seen him since. Then the oddest surprise of all—Archie invites Brayton for a weekend visit and the captain winds up dead. Is it suicide, or is the young Mr. Cranfield as guilty as he looks?<br/><br/> “The Clock” is the first of thirteen enthralling tales of suspense in <i>The Four Corners of the World</i>. A. E. W. Mason’s masterful collection moves from Gibralter to South America, from a brutal wartime drama to a terrible murder solved by the inimitable Inspector Hanaud.<br/><br/> This ebook has been professionally proofread to ensure accuracy and readability on all devices. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. E. W. Mason
      </h2>
      
      <p class="authorDescription body article">A. E. W. Mason (1865&ndash;1948) was a bestselling author of mystery and adventure fiction. He is best remembered for the novel&#160;<I>The Four Feathers&#160;</I>and for his series of mysteries featuring Inspector Hanaud of the Paris S&ucirc;ret&eacute;.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?364f1829